<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
        </v-toolbar>
        <v-img
          src="/static/img/queenlogo.png"
          height="250"
          contain
          pt-5
        ></v-img>

        <div class="headline text-xs-center mb-4">CUSTOM TOOLED RENO RODEO SADDLE RAFFLE</div>

        <v-img
          src="/static/img/cactus_logo.png"
          height="150"
          contain
          pt-5
        ></v-img>

        <div v-if="saved">
          <div class="subheading mx-4">
            <p>The Raffle is closed at this time.</p>
            <!-- <p>You have been entered in the Reno Rodeo Queen Committee raffle for a
              one-of-a-kind, first ever, 16" CACTUS SADDLERY team roper,
              custom tooled with the Reno Rodeo Double R Brand and the Cactus Logo.</p>

              <p>Winning ticket will be pulled at the MRR Coronation Dinner on June 9, 2023.<br />
                *Need not be present to win.</p> -->
          </div>
        </div>
        <div v-else>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-flex xs12>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 md8>
                            <p class="headline">The Reno Rodeo Queen Committee is raffling a
                              one-of-a-kind, first ever, 16" CACTUS SADDLERY team roper,
                              custom tooled with the Reno Rodeo Double R Brand and the Cactus Logo.</p>

                              <p class="headline">Tickets for this raffle are $50.00. ONLY 300 tickets will be sold!</p>

                              <p class="headline">Winning ticket will be pulled at the MRR Coronation Dinner on June 9, 2023.<br />
                                *Need not be present to win.</p>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-img
                              src="/static/img/Cactus_Saddle.jpg"
                              contain
                            ></v-img>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        prepend-icon="person"
                        v-model="editedItem.name"
                        label="Name"
                        :rules="[v => !!v || 'Name is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        prepend-icon="email"
                        label="Email"
                        type="email"
                        v-model="editedItem.email"
                        :rules="emailRules"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        v-model="editedItem.address"
                        label="Address"
                        :rules="[v => !!v || 'Address is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout wrap>
                        <v-flex xs10 md5>
                          <v-text-field
                            v-model="editedItem.city"
                            label="City"
                            :rules="[v => !!v || 'City is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2 md2>
                          <v-text-field
                            v-model="editedItem.state"
                            label="ST"
                            mask="AA"
                            :rules="[v => !!v || 'State is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md5>
                          <v-text-field
                            v-model="editedItem.zip"
                            label="Zipcode"
                            mask="#####"
                            :rules="[v => !!v || 'Zip is required']"
                            required
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="editedItem.phone"
                      label="Phone"
                      mask="(###) ###-####"
                      return-masked-value
                      prepend-icon="stay_current_portrait"
                      :rules="[v => !!v || 'Primary Phone is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1>
                    <v-text-field
                      v-model="editedItem.quantity"
                      label="Quantity"
                      :rules="[v => !!v || 'Quanity is required']"
                      mask="###"
                      @change="calcTotal()"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1>
                    <v-text-field
                      v-model="editedItem.price"
                      label="Price"
                      :rules="[v => !!v || 'Amount is required']"
                      mask="###.##"
                      prefix="$"
                      readonly
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1>
                    <v-text-field
                      v-model="editedItem.amount"
                      label="Amount"
                      :rules="[v => !!v || 'Amount is required']"
                      mask="###.##"
                      prefix="$"
                      readonly
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex class="title text-xs-center mt-4" xs12>
                    <span class="blue--text">CREDIT CARD INFORMATION</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.number"
                      label="Credit Card Number"
                      :rules="[v => !!v || 'Credit Card Number is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.cardName"
                      label="Name on Card"
                      :rules="[v => !!v || 'Name on Card is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md3>
                    <v-text-field
                      v-model="editedItem.expire"
                      label="Expires"
                      mask="##/##"
                      return-masked-value
                      :rules="[v => !!v || 'Expires is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 offset-md1>
                    <v-text-field
                      v-model="editedItem.cvv"
                      label="CVV"
                      mask="####"
                      :rules="[v => !!v || 'CVV is required']"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="save">Submit</v-btn>
          </v-card-actions>
        </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      checkbox: false,
      dates: [],
      saved: true,
      editedItem: {
        quantity: 1,
        price: '50',
        amount: '50'
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      finalsDate: '',
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
    // this.getDates()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    calcTotal () {
      let price = Number(this.editedItem.price)
      let quantity = Number(this.editedItem.quantity)

      let total = price * quantity
      this.editedItem.amount = total
    },

    async getDates () {
      try {
        const response = await Api().get('bsd_dates/' + this.currentYear)

        const dates = response.data

        const selectDates = []
        let date = {}

        for (let i in dates) {
          if (dates[i].status === 'finals') {
            this.finalsDate = moment(String(dates[i].date)).format('MM/DD/YYYY')
          } else {
            date.value = dates[i].date
            date.text = dates[i].night
            selectDates.push(date)
            date = {}
          }
        }

        this.dates = selectDates
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear

        if (this.$refs.form.validate()) {
          const response = await Api().post('extern_raffle', this.editedItem)
          this.editedItem = {}
          this.editedItem.amount = '50'

          this.saved = true

          this.snackbar.message = response.data.message + ' Congratulation, your entry has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/raffle/ExternalForm.vue